
import { MapLocation } from '@/types/location';

export const alBahahDigitalMegacomScreens: MapLocation[] = [
  {
    id: 10069,
    name: "Digital Megacom Screen – Al Bahah",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [19.9996639, 41.4659333], // Converted from 19°59'58.9"N 41°27'57.4"E
    region: "Al Bahah",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/ced42baf-91fe-4537-8697-32a6ed8af95b.png"
    }
  },
  {
    id: 10070,
    name: "Digital Megacom Screen – Al Bahah 2",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [20.0053056, 41.4531944], // Converted from 20°00'19.1"N 41°27'11.5"E
    region: "Al Bahah",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/fe9268b0-63db-41e0-9cdc-57cc33d7ed51.png"
    }
  },
  {
    id: 10071,
    name: "Digital Megacom Screen – Al Bahah 3",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [20.0550278, 41.4475], // Converted from 20°03'18.1"N 41°26'51.0"E
    region: "Al Bahah",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/daa9c69c-df7b-4a9b-8008-ea0a47f0adc8.png"
    }
  }
];